import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  HeadlampIcon,
  headlampPlugin,
} from '@headlamp-k8s/backstage-plugin-headlamp';

/**
 * New-frontend-system wrapper for the Headlamp plugin, which only ships legacy
 * extensions.
 *
 * This is convertLegacyPlugin by hand, so that the plugin can carry a title
 * and icon — those are what the sidebar renders for the auto-discovered nav
 * item, and convertLegacyPlugin has no way to pass them. The legacy API
 * factory is bridged rather than rewritten because the plugin does not export
 * headlampApiRef.
 */
const routes = convertLegacyRouteRefs(headlampPlugin.routes);

const headlampApis = Array.from(headlampPlugin.getApis()).map(factory =>
  ApiBlueprint.make({
    name: factory.api.id,
    params: defineParams => defineParams(factory),
  }),
);

const headlampPage = PageBlueprint.make({
  params: {
    path: '/headlamp',
    routeRef: routes.root,
    loader: async () => {
      const { compatWrapper } = await import('@backstage/core-compat-api');
      const { HeadlampPage } = await import(
        '@headlamp-k8s/backstage-plugin-headlamp'
      );
      return compatWrapper(<HeadlampPage />);
    },
  },
});

export default createFrontendPlugin({
  pluginId: 'headlamp',
  title: 'Headlamp',
  icon: <HeadlampIcon />,
  routes,
  extensions: [...headlampApis, headlampPage],
});
